import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_MetaPathway.scss';
import { Component_Protocols } from '../../home-panel/v2/home-ddx/Component_Protocols/Component_Protocols.js';
export class Component_MetaPathway extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsx(LL_V_L, { id: 'component-meta-pathway', children: _jsx(Component_Protocols, {}) });
    }
}
//# sourceMappingURL=Component_MetaPathway.js.map